import React from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { withStyles } from "@mui/styles";
import { useStyles } from "./indexStyles";
import { Box, Stack, Typography } from "@mui/material";

function SectionTitle({
  classes: {},
  title = "",
  backButton = false,
  onClickHandler = () => {},
  color = "black",
}) {
  return (
    <Box m={1}>
      <Stack
        direction="row"
        gap={1}
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        {backButton === true && (
          <ArrowBackIcon
            fontSize="small"
            onClick={onClickHandler}
            color={color}
          />
        )}
        <Typography variant="h5" color={color}>
          {title}
        </Typography>
      </Stack>
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(SectionTitle);
